import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {QueryCategory} from "../model/queryCategory";
import {StaticsService} from "../sys/statics.service";
import {QueryValue} from "../model/queryValue";

declare var $: any;

@Injectable()
export class QueryManagerService {

    private queryCategories: QueryCategory[] = new Array();
    public queryManagerChangeSubject = new Subject<boolean>();

    constructor(private staticsService: StaticsService) {

    }

    ngOnInit() {

    }

    public refresh() {
        this.queryManagerChangeSubject.next(true);
    }

    public isQueryCategoryInManager(categoryType: string) :boolean {
        let isIn: boolean = false;

        for (let queryCategory  of this.queryCategories) {
            if (queryCategory.type.trim() == categoryType.trim()) {
                isIn = true;
            }
        }

        return isIn;
    }

    public addQueryValueNoSearch(categoryType: string, queryValue: QueryValue, isFilter: boolean) : QueryValue {
        let foundQueryCategory: QueryCategory | null = null;
        let updatedQueryCategories: QueryCategory[] = new Array();
        let newQueryValues: QueryValue[] = new Array();
        let newQueryValue: QueryValue =  new QueryValue();

        for (let queryCategory  of this.queryCategories) {
            if (queryCategory.type.trim() != categoryType.trim()) {
                updatedQueryCategories.push(queryCategory);
            }
            else {
                foundQueryCategory = queryCategory;

            }
        }
        if (foundQueryCategory != null) {
            let isFound: boolean = false;
            for (let queryValueLoop  of foundQueryCategory.queryValues) {
                if (queryValueLoop.value.trim() == queryValue.value) {
                    isFound = true;
                    newQueryValue = queryValueLoop;
                }
            }
            if (!isFound) {
                newQueryValue = queryValue;
                foundQueryCategory.queryValues.push(newQueryValue);
            }
        }
        else {
            let newQueryCategory: QueryCategory = new QueryCategory();

            newQueryValue = queryValue;
            newQueryValues.push(newQueryValue);

            newQueryCategory.isFilter = isFilter;
            newQueryCategory.type = categoryType;
            newQueryCategory.queryValues = newQueryValues;

            this.queryCategories.push(newQueryCategory)
          //  returnQueryValue = newQueryValue;
        }

        this.queryManagerChangeSubject.next(true);

        return newQueryValue;
    }

    public deleteQueryCategory(categoryType:string) {
        let updatedQueryCategories: QueryCategory[] = new Array();

        for (let queryCategory  of this.queryCategories) {
            if (queryCategory.type.trim() != categoryType.trim()) {
                updatedQueryCategories.push(queryCategory);
            }
        }

        this.queryCategories = updatedQueryCategories;
        this.queryManagerChangeSubject.next(true);
    }

    // returns null if not found
    public findQueryValue(value:string, categoryType:string) : QueryValue | null {
        let foundQueryCategory : QueryCategory | null = null;
        let foundQueryValue : QueryValue | null = null;

        if (value != undefined) {
            for (let queryCategory of this.queryCategories) {
                if (queryCategory.type.trim() == categoryType.trim()) {
                    foundQueryCategory = queryCategory;
                }
            }

            if (foundQueryCategory != null) {
                for (let queryValue of foundQueryCategory.queryValues) {

                    if (queryValue.value.trim() == value.trim()) {
                        foundQueryValue = queryValue;
                    }
                }
            }
        }

        return foundQueryValue;
    }

    public updateOrAdd(curQueryValue: QueryValue, newQueryValue: QueryValue,
                       categoryType: string, isFilter: boolean): QueryValue {
        let foundQueryValue: QueryValue | null = this.findQueryValue(curQueryValue.value, categoryType);

        if (foundQueryValue == null) {
            let updatedQueryValue: QueryValue = this.addQueryValueNoSearch(categoryType, newQueryValue, isFilter);
            return updatedQueryValue;
        }
        else {
            this.updateQueryValueForQueryCategory(curQueryValue, newQueryValue, categoryType);
            this.queryManagerChangeSubject.next(true);
            return newQueryValue;
        }

    }

    private updateQueryValueForQueryCategory(curQueryValue: QueryValue, newQueryValue: QueryValue, categoryType: string){

        for (let queryCategory  of this.queryCategories) {
            if (queryCategory.type.trim() == categoryType.trim()) {
                let x: number = 0;
                for (let queryValue  of queryCategory.queryValues) {
                    if (queryValue.value.trim() == curQueryValue.value.trim()) {
                        queryCategory.queryValues[x] = newQueryValue;
                    }
                    x++;
                }
            }
        }
    }

    public deleteQueryValue(value:string, categoryType:string) {

        let foundQueryCategory : QueryCategory | null = null;

        for (let queryCategory  of this.queryCategories) {
            if (queryCategory.type.trim() == categoryType.trim()) {
                foundQueryCategory = queryCategory;
            }
        }
        if (foundQueryCategory != null) {
            if (foundQueryCategory.queryValues.length == 1) {
                this.deleteQueryCategory(categoryType);
            } else {
                let newQueryValues : QueryValue[] = new Array();
                for (let queryValue of foundQueryCategory.queryValues) {
                    if (queryValue.value.trim() != value.trim()) {
                        newQueryValues.push(queryValue);
                    }
                }
                foundQueryCategory.queryValues = newQueryValues;
                this.queryManagerChangeSubject.next(true);
            }
        }
    }

    public reset() {
        this.queryCategories= new Array();
        this.queryManagerChangeSubject.next(true);
    }

    public getQueryCategories(): QueryCategory[] {
        return this.queryCategories;
    }

    public evaluateSearch(queryCategory: QueryCategory, searchValue: string): QueryCategory[] {
        let splitsearchValues: string[] = new Array();

        splitsearchValues = this.splitQuotesAndSpaces(this.clean(queryCategory, searchValue));

        if (splitsearchValues != null) {
            if (searchValue.trim().length > 0) {
                let curQueryCategory: QueryCategory | undefined = this.evaluateQueryCategories(queryCategory);
                if (curQueryCategory) {
                    let cnt: number = curQueryCategory.queryValues.length;
                    for (let splitSearchValue of splitsearchValues) {
                        if (splitSearchValue.trim().length != 0) {
                            if (!this.includes(curQueryCategory.queryValues, splitSearchValue.trim())) {
                            let newQueryValue: QueryValue = new QueryValue();
                            newQueryValue.value = splitSearchValue;
                            newQueryValue.displayValue = newQueryValue.value;
                            curQueryCategory.queryValues[cnt] = newQueryValue;
                            cnt = cnt + 1;
                            }
                        }
                    }
                }
            }
        }
        return this.queryCategories;
    }

    //handle double quotes that are not closed
    private splitQuotesAndSpaces(searchValue: string): string[] {
        let returnSearchValues : string[] = <string[]> searchValue.match(/(\-\".*?\")|[\w,*,(,),&,\-,.,%,@,+,?,!,~,_,;,#,']+|"[^"]+"/g);
        return returnSearchValues;
    }

    //this is needed in case a search like ein is copied in with a format.the back-end does not take care of this
    private clean (queryCategory: QueryCategory, searchValue: string) {
        let str = searchValue;
        if (queryCategory.type == this.staticsService.getCategoryType().EIN) {
            if (searchValue.length > 2) {
                str = searchValue.toString().replace(/-/g, '');
            }

            //if the original value has a leading hyphen, add it back for NOT functionality
            if(searchValue.substring(0,1) ==='-'){
                str = "-"+str;
            }
        }
        return str;
    }

    //adds a new or returns the found one
    private evaluateQueryCategories(queryCategory: QueryCategory) : QueryCategory | undefined {
        let found: boolean = false;
        let foundQueryCategory: QueryCategory | undefined;


        for (let queryCategoryLoop of this.queryCategories) {
            if (queryCategoryLoop.type == queryCategory.type) {
                found = true;
                foundQueryCategory = queryCategoryLoop;
            }
        }
        if (!found) {
            this.queryCategories[this.queryCategories.length] = queryCategory;
            return this.queryCategories[this.queryCategories.length-1];
        }
        else {
            return foundQueryCategory;
        }

    }

    private includes(queryValues: QueryValue[], searchValue: string): boolean {
        let isIncluded: boolean = false;

        for (let queryValue of queryValues) {
            if (queryValue.value.trim().toUpperCase() == searchValue.trim().toUpperCase()) {          
                isIncluded = true;
            }
        }

        return isIncluded;
    }

    public getNonFilterQueryCategories(): QueryCategory[] {
        let foundQueryCategories: QueryCategory[] = new Array();

        for (let queryCategory  of this.getQueryCategories()) {
            if (!queryCategory.isFilter) {
                foundQueryCategories.push(queryCategory);
            }
        }

        return foundQueryCategories;
    }

    public getFilterQueryCategories(): QueryCategory[] {
        let foundQueryCategories: QueryCategory[] = new Array();

        for (let queryCategory  of this.getQueryCategories()) {
            if (queryCategory.isFilter) {
                foundQueryCategories.push(queryCategory);
            }
        }

        return foundQueryCategories;
    }

}
